import React from "react";

/** Centered no-data illustration for empty options history tabs. */
export default function OptionsHistoryEmpty({
  colSpan,
  mobile = false,
  loading = false,
}) {
  const content = (
    <div className="spot_orders_empty_state" role="status">
      {loading ? (
        <div className="text-center text-muted py-4">Loading…</div>
      ) : (
        <img
          src="/images/no-data.svg"
          alt=""
          width={120}
          height={144}
          className="spot_orders_empty_telescope"
        />
      )}
    </div>
  );

  if (mobile) {
    return <div className="no-data-wrapper w-100">{content}</div>;
  }

  return (
    <tr className="no-data-row spot_orders_no_data_row">
      <td colSpan={colSpan}>{content}</td>
    </tr>
  );
}
